import { Component, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { AcceptAccountService } from '../../../../api/api-services/accept-account.service';
import { IAcceptAccountResultVm } from '../../../../api/accept-account-result-vm.model';
import { PasswordModule } from 'primeng/password';
import { currentOskStaffRole, OskStaffRole } from '../../helpers/osk-staff-role';
@Component({
  selector: 'app-osk-invitation-view',
  standalone: true,
  imports: [FormsModule, InputTextModule, ButtonModule, PasswordModule ],
  templateUrl: './osk-invitation-view.component.html',
  styleUrl: './osk-invitation-view.component.scss'
})
export class OskInvitationViewComponent {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private acceptAccountService = inject(AcceptAccountService)
  public email!: string;
  public token!: string;
  public loading: boolean = false;
  public successMessage: string = '';
  public errorMessage: string = '';
  public newPassword: string = '';


  ngOnInit(): void {
    // Get email and token from the URL
    this.activatedRoute.queryParams.subscribe((params) => {
      this.email = decodeURIComponent(params['email'] || '');
      this.token = params['token'] || '';

      if (!this.email || !this.token) {
        this.errorMessage = 'Invalid invitation link.';
        return;
      }

    });
  }

  public onSubmit(): void {
    this.loading = true;
    // ITBees.UserManager reads the set-password token from tokenAuth; `token` stays for older versions.
    const payload = {
      email: this.email,
      token: this.token,
      tokenAuth: this.token,
      newPassword: this.newPassword,
      lang: 'pl'
    };

    this.acceptAccountService.post(payload).subscribe((res: IAcceptAccountResultVm) => {
      if (res.token) {
        localStorage.setItem('authToken', res.token.value);
        // Like the login form: without the expiry the route guard sends the new account back to sign in.
        localStorage.setItem('authTokenExpired', String(res.token.tokenExpirationDate));
        // The owner starts with buying access; an employee lands where their role works.
        this.router.navigate([currentOskStaffRole() === OskStaffRole.Boss ? '/osk-subscriptions/list' : '/students'])
      }
    }, (error: any) => {
      if (error.status) {
        this.errorMessage = error.error?.message || "Wystąpił błąd";
      }
    })
  }

  
}
